export default __webpack_public_path__ + "static/media/liberum-4.c6c1fb23.png";